<template>
  <div class="w-[100vw] h-[100vh] fixed top-0 left-0 z-50 flex justify-center items-center bg-[#0000005a]">
    <div class="text-[var(--text)] gap-4 p-4 bg-[var(--fundoComponente)] rounded-[10px] flex flex-col glass-app popup-content min-w-[32rem]">

      <!-- Header -->
      <div class="w-full gap-[2rem] flex justify-between items-center">
        <h3 class="text-[var(--titulo)]">{{ headerTitle }}</h3>
        <AppButton
          class="text-[var(--text)]"
          :visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="$emit('close')"
          :width="23"
          :height="23"
        />
      </div>

      <!-- Context info -->
      <div class="flex flex-col gap-1 text-xs border-b border-[var(--label)] pb-3">
        <div class="flex gap-2">
          <span class="min-w-[9rem] opacity-70">OS #</span>
          <span>{{ item.ordemServico }}</span>
        </div>
        <div class="flex gap-2">
          <span class="min-w-[9rem] opacity-70">Cliente</span>
          <span>{{ item.cliente_nome }}</span>
        </div>
        <div v-if="item.subcliente_nome && item.subcliente_nome !== item.cliente_nome" class="flex gap-2">
          <span class="min-w-[9rem] opacity-70">Sub-Cliente</span>
          <span>{{ item.subcliente_nome }}</span>
        </div>
        <div class="flex gap-2">
          <span class="min-w-[9rem] opacity-70">Local Instalação</span>
          <span>{{ item.local_instalacao_nome }}</span>
        </div>
        <div class="flex gap-2">
          <span class="min-w-[9rem] opacity-70">Negócio Anterior</span>
          <span>#{{ item.NegocioID }}</span>
        </div>
        <div class="flex gap-2">
          <span class="min-w-[9rem] opacity-70">Data de Início</span>
          <span>{{ today }}</span>
        </div>

        <!-- Estado badge -->
        <div v-if="item.reorcamento_estado" class="flex gap-2 mt-1">
          <span class="min-w-[9rem] opacity-70">Estado</span>
          <span :style="estadoBadgeStyle" class="px-2 py-0.5 rounded-full text-xs font-medium">
            {{ estadoLabel }}
          </span>
        </div>

        <!-- Who handled it -->
        <div v-if="item.reorcamento_tratado_por" class="flex gap-2 mt-1">
          <span class="min-w-[9rem] opacity-70">Tratado por</span>
          <span>{{ item.reorcamento_tratado_por }}</span>
        </div>
      </div>

      <!-- Mode: can create (null or pendente) -->
      <template v-if="canCreate">
        <ValidatedSelect
          name="atribuidoA"
          label="Atribuir a:"
          v-model="selectedUtilizador"
          :options="utilizadores"
          placeholder="Pesquisar utilizador..."
          :required="false"
          :returnObject="true"
          :useMultiselect="true"
        />

        <!-- Observações / Descrição do orçamento -->
        <div class="flex justify-between items-start gap-2 w-full">
          <span class="text-xs opacity-70 w-1/6 pt-1 text-left">Observações:</span>
          <div class="w-3/4">

            <textarea
            v-model="obs"
            rows="3"
            placeholder="Descrição do orçamento..."
            class="w-full flex-1 text-xs rounded p-2 resize-y"
            style="background-color: var(--label); color: var(--text);"
            />
          </div>
        </div>

        <div class="flex gap-2 pt-1">
          <AppButton
            class="flex-1"
            :visibility="true"
            :font_size="12"
            padding="0.3rem 0.7rem"
            color="#3b82f6"
            left_icon="fa-solid fa-pen-to-square"
            text="Criar Orçamento/Corretiva"
            emitType="select"
            @select="confirmar"
          />
          <AppButton
            v-if="canIgnore"
            class="flex-1"
            :visibility="true"
            :font_size="12"
            padding="0.3rem 0.7rem"
            color="#f97316"
            left_icon="fa-solid fa-ban"
            text="Ignorar"
            emitType="select"
            @select="$emit('ignorar')"
          />
        </div>
      </template>

      <!-- Mode: em_curso — negocio exists but not closed -->
      <template v-else-if="item.reorcamento_estado === 'em_curso'">
        <p class="text-xs opacity-70">Já existe um orçamento/corretiva em curso para esta ordem de serviço.</p>
        <AppButton
          :visibility="true"
          :font_size="12"
          padding="0.3rem 0.7rem"
          color="#3b82f6"
          left_icon="fa-solid fa-arrow-up-right-from-square"
          text="Ver Negócio"
          emitType="select"
          @select="$emit('irParaNegocio')"
        />
      </template>

      <!-- Mode: concluido — negocio is closed -->
      <template v-else-if="item.reorcamento_estado === 'concluido'">
        <p class="text-xs opacity-70">O orçamento/corretiva foi concluído com sucesso.</p>
        <AppButton
          :visibility="true"
          :font_size="12"
          padding="0.3rem 0.7rem"
          color="var(--icon)"
          left_icon="fa-solid fa-arrow-up-right-from-square"
          text="Ver Negócio"
          emitType="select"
          @select="$emit('irParaNegocio')"
        />
      </template>

      <!-- Mode: ignorado -->
      <template v-else-if="item.reorcamento_estado === 'ignorado'">
        <p class="text-xs opacity-70">Este reorçamento foi marcado como ignorado.</p>
      </template>

    </div>
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import ValidatedSelect from "@/components/ValidatedSelect.vue";

export default {
  name: "CriarReorcamentoPopUp",
  components: { AppButton, ValidatedSelect },
  props: {
    item: {
      type: Object,
      required: true,
    },
    utilizadores: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close", "confirmar", "ignorar", "irParaNegocio"],
  data() {
    return {
      selectedUtilizador: null,
      obs: `Referente ao Relatório nº ${this.item.id}`,
      today: new Date().toISOString().split("T")[0],
    };
  },
  computed: {
    canCreate() {
      return !this.item.reorcamento_estado || this.item.reorcamento_estado === "pendente";
    },
    canIgnore() {
      return (
        this.item.reorcamentar &&
        (!this.item.reorcamento_estado || this.item.reorcamento_estado === "pendente")
      );
    },
    headerTitle() {
      const titles = {
        em_curso:  "Orçamento/Corretiva em Curso",
        concluido: "Orçamento/Corretiva Concluído",
        ignorado:  "Reorçamento Ignorado",
      };
      return titles[this.item.reorcamento_estado] || "Criar Orçamento/Corretiva";
    },
    estadoLabel() {
      const labels = {
        pendente:  "Pendente",
        em_curso:  "Em Curso",
        concluido: "Concluído",
        ignorado:  "Ignorado",
      };
      return labels[this.item.reorcamento_estado] || "";
    },
    estadoBadgeStyle() {
      const styles = {
        pendente:  "background:#ef444420;color:#ef4444",
        em_curso:  "background:#3b82f620;color:#3b82f6",
        concluido: "background:#22c55e20;color:#22c55e",
        ignorado:  "background:#f9731620;color:#f97316",
      };
      return styles[this.item.reorcamento_estado] || "";
    },
  },
  methods: {
    confirmar() {
      this.$emit("confirmar", {
        atribuido_a_id: this.selectedUtilizador?.id || 0,
        obs: this.obs,
      });
    },
  },
};
</script>
